/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { darken, SxProps, Theme } from '@mui/material';

export const loginButtonSX: SxProps<Theme> = {
	width: '100%',
	borderRadius: '22px',
	paddingTop: '9px',
	paddingBottom: '9px',
	fontSize: '15px',
};

export const createAccountLabelSX: SxProps<Theme> = (theme) => ({
	color: '#2C2C2C',
	fontSize: '18px',
	[theme.breakpoints.down('sm')]: {
		fontSize: 'var(--font-size-sm)',
	},
});

export const createAccountButtonSX: SxProps<Theme> = {
	width: '100%',
	borderRadius: '22px',
	paddingTop: '9px',
	paddingBottom: '9px',
	background: '#F1F1F1 0% 0% no-repeat padding-box',
	color: '#2C2C2C',
	fontSize: 'var(--font-size-body)',
	fontWeight: 'bold',
	'&:hover': {
		background: darken('#F1F1F1', 0.1),
	},
};
